import { render, staticRenderFns } from "./BlogTextBlock.vue?vue&type=template&id=2c6abc64&scoped=true&"
import script from "./BlogTextBlock.vue?vue&type=script&lang=js&"
export * from "./BlogTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./BlogTextBlock.vue?vue&type=style&index=0&id=2c6abc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6abc64",
  null
  
)

export default component.exports